import hexToRGBA from "../hexToRGBA";
import { baseShadowsByTheme } from "../baseShadows";
import { baseColorsByTheme} from "../baseColors";
import { baseGradientsByTheme } from "../baseGradients";

export type BaseColors = {
  primary: string;
  darkPrimary: string;
  lightPrimary: string;
  transparent: string;
  secondary: string;
  darkSecondary: string;
  lightSecondary: string;
  red: string;
  lightRed: string;
  whiteRed: string;
  coolGrey: string;
  orange: string;
  darkOrange: string;
  lightOrange: string;
  paleOrange: string;
  limeGreen: string;
  success: string;
  successLight: string;
  warning: string;
  warningLight: string;
  danger: string;
  dangerLight: string;
  advice: string;
  adviceLight: string;
  paleLimeGreen: string;
  veryDarkBlue: string;
  veryDarkBlue2: string;
  darkBlue: string;
  darkBlue2: string;
  moderateBlue: string;
  white: string;
  grey50: string;
  grey45: string;
  grey40: string;
  grey35: string;
  grey30: string;
  grey25: string;
  grey20: string;
  grey10: string;
  grey05: string;
  black: string;
  textPrimary: string;
  textSecondary: string;
  textDisabled: string;
  formLabel: string;
};

export type Shadows = {
  shadowSmall: string;
  shadowMedium: string;
  shadowMediumHover: string;
  shadowLarge: string;
  shadowPrimarySmall: string;
  shadowPrimaryMedium: string;
  shadowPrimaryLarge: string;
};

export type Gradients = {
  primaryButtonGradient: string;
  switchGradient: string;
  darkBlueGradient: string;
  glowGradient: string;
};

export type InternalThemeConfig = {
  palette: BaseColors;
  shadows: Shadows;
  gradients: Gradients;
  spacing: (fact: number) => string;
};

export type ThemeConfig = Partial<InternalThemeConfig>;

export type BaseTheme = "green" | "orange";

type CezThemeConfig = {
  setBaseColor: (baseColor: BaseTheme) => void;
  updateConfig: (newConfig?: ThemeConfig) => void;
  getConfig: () => InternalThemeConfig;
  config: InternalThemeConfig;
};

const internalConfig: CezThemeConfig = (() => {
  let config: InternalThemeConfig = {
    palette: baseColorsByTheme(),
    shadows: baseShadowsByTheme(),
    gradients: baseGradientsByTheme(),
    spacing: (fact: number) => `${Math.round(0.8 * fact * 1000) / 1000}rem`,
  };

  const setBaseColor = (baseTheme: BaseTheme) => {
    config = {
      palette: baseColorsByTheme(baseTheme),
      shadows: baseShadowsByTheme(baseTheme),
      gradients: baseGradientsByTheme(baseTheme),
      spacing: (fact: number) => `${Math.round(0.8 * fact * 1000) / 1000}rem`,
    };
  };

  const updateConfig = (newConfig?: ThemeConfig) =>
    (config = { ...config, ...newConfig });

  const getConfig = (): InternalThemeConfig => {
    return config;
  };

  return {
    setBaseColor,
    updateConfig,
    config,
    getConfig,
  };
})();

export { hexToRGBA };
export default internalConfig;
